import { render, staticRenderFns } from "./FlattenTopBarIcon.vue?vue&type=template&id=b36b8868&"
import script from "./FlattenTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./FlattenTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports